import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

const PageFirstIcon = ({ ...props }) => {
    return (React.createElement(SvgIcon, { ...props, viewBox: "0 0 11 12" },
        React.createElement("path", { d: "M2 10.5V1.50004C2 1.2239 1.77614 1.00004 1.5 1.00004H0.5C0.22386 1.00004 0 1.2239 0 1.50004V10.5C0 10.7762 0.22386 11 0.5 11H1.5C1.77614 11 2 10.7762 2 10.5Z" }),
        React.createElement("path", { d: "M8.99992 0.646582L4 5.6465C3.80474 5.84176 3.80474 6.15834 4 6.35361L8.99992 11.3535C9.19518 11.5488 9.51176 11.5488 9.70703 11.3535L10.414 10.6466C10.6093 10.4513 10.6093 10.1347 10.414 9.93946L6.47457 6.00004L10.414 2.06062C10.6093 1.86536 10.6093 1.54878 10.414 1.35351L9.70703 0.646552C9.51177 0.451292 9.19519 0.451322 8.99992 0.646582Z" })));
};

export { PageFirstIcon };
//# sourceMappingURL=PageFirstIcon.esm.js.map
